// URL base de los archivos subidos: un bucket/CDN (VUE_APP_FILES_URL) o,
// por defecto, el /storage del backend.
const FILES_URL = (process.env.VUE_APP_FILES_URL || process.env.VUE_APP_API_URL + '/storage').replace(/\/+$/, '');

/**
 * Construye la URL pública de un archivo a partir de la ruta guardada en el
 * backend. Tolera el prefijo `/` y `storage/`, y deja pasar URLs completas.
 */
export function fileUrl(path) {
    const value = String(path || '');

    if (/^https?:\/\//.test(value)) {
        return value;
    }

    return FILES_URL + '/' + value.replace(/^\/+/, '').replace(/^storage\//, '');
}
